import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2HeaderLabelSx = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} satisfies SxProps<Theme>;
